export const navCountReducer = (
	state = {
		active_customer: 0,
		bill_count: 0,
		products_count: 0,
		ingredients_count: 0,
		clubs_count: 0,
		athletes_count: 0,
		not_found_products_count: 0,
		report_count: 0,
		subscription_count: 0,
	},
	action
) => {
	switch (action.type) {
		case "NAV_CUSTOMER_COUNT":
			return {
				...state,
				active_customer: action?.payload,
			};

		case "NAV_BILL_COUNT":
			return {
				...state,
				bill_count: action?.payload,
			};

		case "NAV_PRODUCTS_COUNT":
			return {
				...state,
				products_count: action?.payload,
			};
		case "NAV_INGREDIENTS_COUNT":
			return {
				...state,
				ingredients_count: action?.payload,
			};

		case "NAV_CLUBS_COUNT":
			return {
				...state,
				clubs_count: action?.payload,
			};
		case "NAV_ATHLETES_COUNT":
			return {
				...state,
				athletes_count: action?.payload,
			};
		case "NAV_NOT_FOUND_PRODUCT_COUNT":
			return {
				...state,
				not_found_products_count: action?.payload,
			};
		case "NAV_REPORT_COUNT":
			return {
				...state,
				report_count: action?.payload,
			};
		case "NAV_SUBSCRIPTION_COUNT":
			return {
				...state,
				subscription_count: action?.payload,
			};

		default:
			return state;
	}
};
